<template>
    <section class="p-[16px]">
        <div class="mb-[16px]">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Exceptions</h2>
        </div>
        <div class="grid grid-cols-4 gap-x-[16px] h-[80px] mb-[16px]">
            <div class="size-full rounded-xl border" />
            <div class="size-full rounded-xl border" />
            <div class="size-full rounded-xl border" />
            <div class="size-full rounded-xl border" />
        </div>
        <div class="">
            <!-- <div class="row clearfix">
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div class="info-box-3 bg-blak hover-zoom-effect">
                        <div class="icon">
                            <i class="material-icons">assignment_late</i>
                        </div>
                        <div class="content">
                            <h2 class="text">EXEPTIONS</h2>
                            <div class="number">{{ data.exceptions }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div class="info-box-3 bg-blue-grey hover-zoom-effect">
                        <div class="icon">
                            <i class="material-icons">call_missed</i>
                        </div>
                        <div class="content">
                            <h2 class="text">ABSENCES</h2>
                            <div class="number">{{ data.absences }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div class="info-box-3 bg-blue-grey hover-zoom-effect">
                        <div class="icon">
                            <i class="material-icons">alarm_off</i>
                        </div>
                        <div class="content">
                            <h2 class="text">RETARDS</h2>
                            <div class="number">{{ data.retards }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <div class="info-box-3 bg-blue-grey hover-zoom-effect">
                        <div class="icon">
                            <i class="material-icons">directions_run</i>
                        </div>
                        <div class="content">
                            <h2 class="text">DÉPART ANTICIPÉS</h2>
                            <div class="number">{{ data.departs }}</div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="block-header">
                <h2>REGISTRE</h2>
            </div> -->
            <!-- REGISTRE -->
            <ExceptionTableComponent/>

            <!-- <div class="block-header">
                <h2>CLASSEMENT</h2>
            </div> -->
            <!-- CLASSEMENT -->
            <!-- <ExceptionClassementTableComponent/> -->

        </div>

    </section>
</template>

<script>
import ExceptionTableComponent from '@/components/tables/ExceptionTable'
// import ExceptionClassementTableComponent from '@/components/tables/ExceptionClassementTable'
import API from "../../service/API.js"

export default {
    name: 'ExceptionView',
    components: {
        ExceptionTableComponent,
        // ExceptionClassementTableComponent
    },
    data() {
        return {
            loader: false,
            data: {},
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData(){
            this.loader = true
            API.get('/getExptionsDetails')
                .then((res) => {
                    this.data.exceptions = res.data.exceptions
                    this.data.absences = res.data.absences
                    this.data.retards = res.data.retards
                    this.data.departs = res.data.departs
                    this.loader = false

                })
                .catch(() => {
                    this.loader = false
                })
        },
    }
}

</script>